import { createContext } from 'react';
export const AuthContext = createContext({});
export const AuthContextConsumer = AuthContext.Consumer;
